import * as types from "./types";
import {
    getMarketingCampaign,
    getMarketingCampaignById,
    postMarketingCampaign,
    putMarketingCampaign,
    deleteMarketingCampaign
} from "./services";



export async function getMarketingCampaignAction({ commit }) {
    commit(types.LOADING_CAMPAIGN, true);
    try {
        const { data } = await getMarketingCampaign();
        commit(types.GET_CAMPAIGN, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_CAMPAIGN, false);
    }
}

export async function getMarketingCampaignByIdAction({ commit }, id) {
    commit(types.LOADING_CAMPAIGN, true);
    try {
        const { data } = await getMarketingCampaignById(id);
        commit(types.GET_CAMPAIGN_ID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_CAMPAIGN, false);
    }
}

export async function postMarketingCampaignAction({ commit }, payload) {
    commit(types.LOADING_CAMPAIGN, true);
    try {
        await postMarketingCampaign(payload);
        commit(types.POST_CAMPAIGN_ID, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_CAMPAIGN, false);
    }
}

export async function putMarketingCampaignAction({ commit }, payload) {
    commit(types.LOADING_CAMPAIGN, true);
    try {
        await putMarketingCampaign(payload);
        commit(types.UPDATE_CAMPAIGN, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_CAMPAIGN, false);
    }
}


export async function deleteMarketingCampaignAction({ commit }, id) {
    commit(types.LOADING_CAMPAIGN, true);
    try {
        await deleteMarketingCampaign(id);
        commit(types.DELETE_CAMPAIGN, id);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_CAMPAIGN, false);
    }
}